import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";
import { useDialogContentContext } from "./DialogContext";
import { DIVIDED_REGION_CLASS } from "./styles";

export type DialogFooterProps = ComponentProps<"div">;

export const DialogFooter = ({ className, ...props }: DialogFooterProps) => {
  const { divided } = useDialogContentContext();

  return (
    <div
      data-slot="dialog-footer"
      className={cn(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        divided && DIVIDED_REGION_CLASS,
        className
      )}
      {...props}
    />
  );
};
